import { render, staticRenderFns } from "./GlobalWebSocket.vue?vue&type=template&id=4f47a59b"
import script from "./GlobalWebSocket.vue?vue&type=script&lang=js"
export * from "./GlobalWebSocket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports